export const orangeOffWhite = {
  label: "Amber Dusk",
  background: "#fcfaf8",
  textColor: "#2a2825",
  typeBoxText: "#ff7b00",
};

export const darkOrange = {
  label: "Burnt Ember",
  background: "#121212",
  textColor: "#e0e0e0",
  typeBoxText: "#ff7b00",
};

export const oceanBlue = {
  label: "Azure Breeze",
  background: "#f0f4f8",
  textColor: "#102a43",
  typeBoxText: "#007bb5",
};

export const darkOcean = {
  label: "Midnight Tide",
  background: "#0b192c",
  textColor: "#e1e7f0",
  typeBoxText: "#00a8ff",
};

export const forestGreen = {
  label: "Forest Mist",
  background: "#f1f8f5",
  textColor: "#143326",
  typeBoxText: "#2eb872",
};

export const cyberpunk = {
  label: "Neon Pulse",
  background: "#0d0221",
  textColor: "#0ff0fc",
  typeBoxText: "#ff007f",
};

export const minimalistGray = {
  label: "Slate Minimal",
  background: "#fafafa",
  textColor: "#202020",
  typeBoxText: "#888888",
};

export const themeOptions = [
  { label: "Amber Dusk", value: orangeOffWhite },
  { label: "Burnt Ember", value: darkOrange },
  { label: "Azure Breeze", value: oceanBlue },
  { label: "Midnight Tide", value: darkOcean },
  { label: "Forest Mist", value: forestGreen },
  { label: "Neon Pulse", value: cyberpunk },
  { label: "Slate Minimal", value: minimalistGray },
];

export const loginTheme = {
  background: "#fcfaf8",
  textColor: "#2a2825",
  typeBoxText: "#ff7b00",
};
